/*
 * Zen & Zip — gender-aware product gallery.
 * Unisex products can set zz_product.lead_men / lead_women (media IDs). The
 * product page prints them in #zz-gender-lead (snippets/zz-gender-lead-data).
 * When the shopper arrives from a men's or women's collection, the gallery
 * opens on the matching photo. Matches the card logic in snippets/product-card
 * (collection handle containing "womens" -> women, containing "mens" -> men).
 * Order of the gallery itself is unchanged; this only selects the slide.
 */
(function () {
  function contextFromReferrer() {
    try {
      if (!document.referrer) return '';
      var u = new URL(document.referrer);
      if (u.origin !== location.origin) return '';
      var m = u.pathname.match(/\/collections\/([^\/?#]+)/);
      if (!m) return '';
      var h = m[1];
      if (h.indexOf('womens') > -1) return 'women';
      if (h.indexOf('mens') > -1) return 'men';
    } catch (e) {}
    return '';
  }

  function slideHasId(slide, id) {
    if (!slide) return false;
    if (slide.getAttribute('data-media-id') === id || slide.getAttribute('data-id') === id) return true;
    return !!slide.querySelector('[data-media-id="' + id + '"]');
  }

  function init() {
    var holder = document.getElementById('zz-gender-lead');
    if (!holder) return;
    var data;
    try { data = JSON.parse(holder.textContent); } catch (e) { return; }
    var ctx = contextFromReferrer();
    var id = ctx && data[ctx];
    if (!id) return;

    var tries = 0;
    (function attempt() {
      var done = false;
      document.querySelectorAll('carousel-component').forEach(function (cc) {
        if (!cc.embla || !/product-media-carousel/.test(cc.className)) return;
        var slides = cc.embla.slideNodes();
        for (var i = 0; i < slides.length; i++) {
          if (slideHasId(slides[i], String(id))) {
            if (cc.embla.selectedScrollSnap() !== i) cc.embla.scrollTo(i, true);
            done = true;
            break;
          }
        }
      });
      if (!done && tries++ < 25) setTimeout(attempt, 150);
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
